import { get } from 'lodash';
export const getError = (err) => {
    if (!err)
        return;
    if (err.status === 401)
        return;
    return get(err, 'data.error', err);
};
export const getAnyError = (err) => {
    if (!err)
        return;
    return get(err, 'data.error', err);
};
